/* Bokforslag som lukker fri frakt-gapet (gursliberg.no, CRO P1 #4, sept 2026).
   Henter pool fra #gb-cart-recs-data (snippets/gb-cart-recs.liquid) og viser
   inntil 3 boeker rett under progressbaren naar kunden mangler noe til 300 kr.

   Holdt bevisst adskilt fra gb-free-shipping.js: de to koordinerer bare via
   DOM-plassering, saa en feil i forslagene kan ikke velte progressbaren.

   NB: her brukes BEVISST ingen backslash-escapes i regex. Filene skrives via
   Admin API-ets themeFilesUpsert, og GraphQL block-strings tolker ikke \ som
   escape - en '\\{' i kilden blir to tegn i fila og gir syntaksfeil.

   GRENSE: samme data-gb-threshold som gb-free-shipping.js. Hold dem i synk. */
(function () {
  var el = document.currentScript;
  var THRESHOLD = parseInt((el && el.getAttribute('data-gb-threshold')) || '30000', 10);
  var MONEY_FMT = (el && el.getAttribute('data-gb-money')) || '{{amount_with_comma_separator}} kr';
  var MAX = 3;
  var pool = [];

  try {
    var node = document.getElementById('gb-cart-recs-data');
    if (node) pool = JSON.parse(node.textContent) || [];
  } catch (e) {
    pool = [];
  }

  function money(cents) {
    var v = cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2).replace('.', ',');
    return MONEY_FMT.replace(/{{[^}]*}}/, v);
  }

  /* Billigste bok som alene lukker gapet foerst. Finnes ingen slik, vis de
     dyreste vi har - de bringer kunden naermest grensen. */
  function pick(remaining, inCart) {
    var free = pool.filter(function (x) { return inCart.indexOf(x.v) === -1; });
    var closes = free.filter(function (x) { return x.p >= remaining; });
    if (closes.length) {
      closes.sort(function (a, b) { return a.p - b.p; });
      return closes.slice(0, MAX);
    }
    free.sort(function (a, b) { return b.p - a.p; });
    return free.slice(0, MAX);
  }

  function card(item) {
    var li = document.createElement('li');
    li.className = 'gb-recs__item';
    var img = item.i
      ? '<img class="gb-recs__img" src="' + item.i + '" alt="" loading="lazy" width="48" height="72">'
      : '<span class="gb-recs__img gb-recs__img--empty"></span>';
    li.innerHTML =
      '<a class="gb-recs__link" href="' + item.u + '">' + img + '</a>' +
      '<div class="gb-recs__body">' +
      '<a class="gb-recs__title" href="' + item.u + '"></a>' +
      '<span class="gb-recs__price">' + money(item.p) + '</span>' +
      '</div>' +
      '<button type="button" class="gb-recs__add" data-vid="' + item.v + '">Legg til</button>';
    li.querySelector('.gb-recs__title').textContent = item.t;
    li.querySelector('.gb-recs__add').addEventListener('click', function () {
      add(item.v, li.querySelector('.gb-recs__add'));
    });
    return li;
  }

  function add(variantId, button) {
    button.disabled = true;
    button.textContent = 'Legger til …';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble']
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
          drawer.renderContents(state);
          setTimeout(boot, 120);
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = 'Legg til';
      });
  }

  function render(bar, remaining, inCart) {
    var host = bar.parentNode;
    var old = host.querySelector('.gb-recs');
    if (old) old.remove();
    if (remaining <= 0) return;
    var items = pick(remaining, inCart);
    if (!items.length) return;

    var box = document.createElement('div');
    box.className = 'gb-recs';
    box.innerHTML = '<p class="gb-recs__lead">Legg til én av disse og få fri frakt:</p><ul class="gb-recs__list"></ul>';
    var list = box.querySelector('.gb-recs__list');
    items.forEach(function (it) { list.appendChild(card(it)); });
    bar.parentNode.insertBefore(box, bar.nextSibling);
  }

  function update() {
    if (!pool.length) return;
    if (!document.querySelector('.gb-shipping-bar')) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = (cart.items || []).map(function (i) { return i.variant_id; });
        var remaining = THRESHOLD - cart.total_price;
        var bars = document.querySelectorAll('.gb-shipping-bar');
        Array.prototype.forEach.call(bars, function (bar) {
          render(bar, cart.item_count === 0 ? 0 : remaining, inCart);
        });
      })
      .catch(function () {});
  }

  /* Progressbaren tegnes av gb-free-shipping.js, saa vi venter paa at den
     finnes i DOM-en foer vi henger oss under den. */
  function boot() {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (document.querySelector('.gb-shipping-bar')) { clearInterval(t); update(); }
      else if (tries > 20) { clearInterval(t); }
    }, 150);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);

  var _fetch = window.fetch;
  window.fetch = function () {
    var a = arguments[0];
    var url = a && a.url ? a.url : String(a || '');
    var p = _fetch.apply(this, arguments);
    if (url.indexOf('/cart/add') > -1 || url.indexOf('/cart/change') > -1 || url.indexOf('/cart/update') > -1 || url.indexOf('/cart/clear') > -1) {
      p.then(function () { setTimeout(boot, 120); }).catch(function () {});
    }
    return p;
  };
})();